<div class="signup-container">
  <!-- Background Animation -->
  <div class="background-animation">
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
      <div class="shape shape-5"></div>
      <div class="shape shape-6"></div>
    </div>
  </div>

  <!-- Main Signup Card -->
  <div class="signup-card" [class.shake]="showShakeAnimation">
    <!-- Header -->
    <div class="signup-header">
      <div class="logo-container">
        <div class="logo">
          <img src="/assets/images/logo.png" alt="Familitive Logo" 
               onerror="this.style.display='none'; this.nextElementSibling?.style.setProperty('display', 'inline-flex');" />
          <!-- Fallback SVG if image fails to load -->
          <svg class="logo-fallback" style="display: none;" width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
            <path d="M19 15L19.5 17.5L22 18L19.5 18.5L19 21L18.5 18.5L16 18L18.5 17.5L19 15Z" fill="currentColor"/>
            <path d="M5 15L5.5 17.5L8 18L5.5 18.5L5 21L4.5 18.5L2 18L4.5 17.5L5 15Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      <h1 class="signup-title">Join Familitive</h1>
      <p class="signup-subtitle">Create your family profile and connect with loved ones</p>
    </div>

    <!-- Google Sign-Up Option -->
    <div class="google-signup-section" *ngIf="false">
      <div class="divider">
        <span>Quick Sign Up with</span>
      </div>
      <div id="google-signup-button" class="google-signin-container"></div>
      <div class="divider">
        <span>or fill the form below</span>
      </div>
    </div>

    <!-- Signup Form -->
    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form">
      
      <!-- Personal Information Section -->
      <div class="form-section">
        <h3 class="section-title">Personal Information</h3>
        
        <div class="form-row">
            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <input 
                type="text" 
                class="form-input"
                formControlName="firstName"
                [class.error]="signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched"
                placeholder="First Name"
                autocomplete="given-name">
              <div class="input-focus-line"></div>
            </div>
            <div class="error-message" *ngIf="signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
              </svg>
                First name is required
            </div>
          </div>

            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <input 
                type="text" 
                class="form-input"
                formControlName="lastName"
                [class.error]="signupForm.get('lastName')?.invalid && signupForm.get('lastName')?.touched"
                placeholder="Last Name"
                autocomplete="family-name">
              <div class="input-focus-line"></div>
            </div>
            <div class="error-message" *ngIf="signupForm.get('lastName')?.invalid && signupForm.get('lastName')?.touched">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
              </svg>
                Last name is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
              <input 
              type="text" 
              class="form-input"
              formControlName="middleName"
              placeholder="Middle Name (Optional)"
              autocomplete="additional-name">
            <div class="input-focus-line"></div>
          </div>
        </div>

        <div class="form-row">
            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2"/>
                  <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2"/>
                  <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <input 
                type="date" 
                class="form-input"
                formControlName="dateOfBirth"
                [class.error]="signupForm.get('dateOfBirth')?.invalid && signupForm.get('dateOfBirth')?.touched">
              <div class="input-focus-line"></div>
            </div>
            <div class="error-message" *ngIf="signupForm.get('dateOfBirth')?.invalid && signupForm.get('dateOfBirth')?.touched">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
              </svg>
                Date of birth is required
            </div>
          </div>

            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="8" r="5" stroke="currentColor" stroke-width="2"/>
                  <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <select 
                class="form-input"
                formControlName="gender"
                [class.error]="signupForm.get('gender')?.invalid && signupForm.get('gender')?.touched">
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
              <div class="input-focus-line"></div>
            </div>
            <div class="error-message" *ngIf="signupForm.get('gender')?.invalid && signupForm.get('gender')?.touched">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
              </svg>
                Gender is required
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                  <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
                  <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <select 
                class="form-input"
                formControlName="maritalStatus">
                <option value="">Marital Status (Optional)</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
                <option value="Separated">Separated</option>
                <option value="Other">Other</option>
              </select>
              <div class="input-focus-line"></div>
          </div>
        </div>

        <div class="form-group">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="isDeceased">
            <span class="checkmark"></span>
            Mark as deceased
          </label>
          </div>
        </div>
      </div>

      <!-- Contact Information Section -->
      <div class="form-section">
        <h3 class="section-title">Contact Information</h3>
        
        <div class="form-group">
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" stroke-width="2"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <input 
              type="email" 
              class="form-input"
              formControlName="email"
              [class.error]="signupForm.get('email')?.invalid && signupForm.get('email')?.touched"
              placeholder="Email Address (Required if mobile not provided)"
              autocomplete="email">
            <div class="input-focus-line"></div>
          </div>
          <div class="error-message" *ngIf="signupForm.get('email')?.invalid && signupForm.get('email')?.touched">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
              <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
            </svg>
            <span *ngIf="signupForm.get('email')?.errors?.['email']">Please enter a valid email</span>
          </div>
          <small class="help-text" style="margin-top: 6px; color: #718096; font-size: 12px; display: block;">
            At least one of email or mobile number is required
          </small>
        </div>

        <div class="form-group">
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.59531 1.99522 8.06679 2.16708 8.43376 2.48353C8.80073 2.79999 9.03996 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5865 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
            <input 
              type="tel" 
              class="form-input"
              formControlName="mobileNumber"
              [class.error]="signupForm.get('mobileNumber')?.invalid && signupForm.get('mobileNumber')?.touched"
              placeholder="Mobile Number (Required if email not provided)"
              autocomplete="tel">
            <div class="input-focus-line"></div>
          </div>
          <div class="error-message" *ngIf="signupForm.get('mobileNumber')?.invalid && signupForm.get('mobileNumber')?.touched">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
              <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
            </svg>
            <span *ngIf="signupForm.get('mobileNumber')?.errors?.['mobile']">Please enter a valid mobile number (at least 10 digits)</span>
          </div>
        </div>

        <div class="form-row">
            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <input 
                type="text" 
                class="form-input"
                formControlName="qualification"
                placeholder="Qualification (Optional)">
              <div class="input-focus-line"></div>
            </div>
          </div>

            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" stroke-width="2"/>
                  <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <input 
                type="text" 
                class="form-input"
                formControlName="profession"
                placeholder="Profession (Optional)">
              <div class="input-focus-line"></div>
            </div>
            </div>
        </div>

            <div class="form-group">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8 2 5 5 5 9C5 14 12 22 12 22C12 22 19 14 19 9C19 5 16 2 12 2Z" stroke="currentColor" stroke-width="2"/>
                  <circle cx="12" cy="9" r="2" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
              <input 
                type="text" 
                class="form-input"
                formControlName="location"
                placeholder="Location (Optional)">
              <div class="input-focus-line"></div>
            </div>
          </div>
        </div>

      <!-- Family Information Section -->
      <div class="form-section">
        <h3 class="section-title">Family Information</h3>
        
            <!-- Parent Information Display (when coming from hierarchy) -->
        <div class="parent-info-display" *ngIf="parentName && parentReferralCode">
          <div class="parent-info-card">
            <div class="parent-info-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
                <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
              </svg>
              <span>Adding as child of:</span>
            </div>
            <div class="parent-info-content">
              <div class="parent-name">{{ parentName }}</div>
              <div class="parent-referral-code">Referral Code: {{ parentReferralCode }}</div>
            </div>
          </div>
        </div>

        <!-- Spouse Information Display (when coming from referral link) -->
        <div class="parent-info-display spouse-info-display" *ngIf="selectedSpouse && spouseReferralCode && !parentReferralCode">
          <div class="parent-info-card spouse-info-card">
            <div class="parent-info-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
                <circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M11 11L13 13" stroke="currentColor" stroke-width="2"/>
              </svg>
              <span>Adding as spouse of:</span>
            </div>
            <div class="parent-info-content">
              <div class="parent-name">{{ selectedSpouse.firstName }} {{ selectedSpouse.lastName }}</div>
              <div class="parent-referral-code">Referral Code: {{ signupForm.get('spouseReferralCode')?.value || spouseReferralCode }}</div>
            </div>
          </div>
        </div>

        <!-- Parent Selection (Optional) -->
        <div class="form-group">
          <label class="form-label">Parent/Child Relationship (Optional)</label>
          <div class="searchable-dropdown-container">
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
                <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
              <input 
                type="text" 
                class="form-input"
                [(ngModel)]="parentSearchTerm"
                [ngModelOptions]="{standalone: true}"
                (input)="searchRelatives(parentSearchTerm, 'parent')"
                (focus)="showParentDropdown = true"
                placeholder="Search for parent (type name to search)"
                autocomplete="off">
              <button 
                *ngIf="selectedParent" 
                type="button"
                class="clear-selection-btn"
                (click)="clearParent()"
                title="Clear selection">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
                  <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <div class="input-focus-line"></div>
            </div>
            <!-- Search Results Dropdown -->
            <div class="dropdown-results" *ngIf="showParentDropdown && parentSearchResults.length > 0">
              <div 
                class="dropdown-item"
                *ngFor="let relative of parentSearchResults"
                (click)="selectParent(relative)">
                <div class="dropdown-item-name">{{ relative.firstName }} {{ relative.middleName || '' }} {{ relative.lastName }}</div>
                <div class="dropdown-item-details">
                  <span *ngIf="relative.email">{{ relative.email }}</span>
                  <span *ngIf="relative.mobileNumber"> • {{ relative.mobileNumber }}</span>
                </div>
              </div>
            </div>
            <div class="dropdown-results" *ngIf="showParentDropdown && isLoadingRelatives">
              <div class="dropdown-item loading">Searching...</div>
            </div>
            <div class="dropdown-results" *ngIf="showParentDropdown && !isLoadingRelatives && parentSearchTerm.length >= 2 && parentSearchResults.length === 0">
              <div class="dropdown-item no-results">No relatives found</div>
            </div>
          </div>
          <!-- Manual Referral Code Input (fallback) -->
          <div class="manual-code-input" *ngIf="selectedParent || parentSearchTerm.length > 0 || (parentReferralCode && parentReferralCode.length > 0)">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
            <input 
              type="text" 
              class="form-input"
              formControlName="parentReferralCode"
                placeholder="Or enter referral code manually"
                [readonly]="selectedParent"
              (blur)="validateReferralCode()">
            <div class="input-focus-line"></div>
            </div>
            <small class="help-text" *ngIf="selectedParent">Referral code auto-filled from selection above</small>
            <small class="help-text" *ngIf="!selectedParent">You can also enter the referral code manually</small>
          </div>
          <small class="help-text" *ngIf="!selectedParent && !parentSearchTerm && !parentReferralCode">You can skip this and set parent relationship later after login</small>
        </div>

        <!-- Spouse Selection (Optional) -->
        <div class="form-group">
          <label class="form-label">Spouse Relationship (Optional)</label>
          <div class="searchable-dropdown-container">
          <div class="input-container">
            <div class="input-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
                <circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
                <path d="M11 11L13 13" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>
              <input 
                type="text" 
                class="form-input"
                [(ngModel)]="spouseSearchTerm"
                [ngModelOptions]="{standalone: true}"
                (input)="searchRelatives(spouseSearchTerm, 'spouse')"
                (focus)="showSpouseDropdown = true"
                placeholder="Search for spouse (type name to search)"
                autocomplete="off">
              <button 
                *ngIf="selectedSpouse" 
                type="button"
                class="clear-selection-btn"
                (click)="clearSpouse()"
                title="Clear selection">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
                  <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
              <div class="input-focus-line"></div>
            </div>
            <!-- Search Results Dropdown -->
            <div class="dropdown-results" *ngIf="showSpouseDropdown && spouseSearchResults.length > 0">
              <div 
                class="dropdown-item"
                *ngFor="let relative of spouseSearchResults"
                (click)="selectSpouse(relative)">
                <div class="dropdown-item-name">{{ relative.firstName }} {{ relative.middleName || '' }} {{ relative.lastName }}</div>
                <div class="dropdown-item-details">
                  <span *ngIf="relative.email">{{ relative.email }}</span>
                  <span *ngIf="relative.mobileNumber"> • {{ relative.mobileNumber }}</span>
                </div>
              </div>
            </div>
            <div class="dropdown-results" *ngIf="showSpouseDropdown && isLoadingRelatives">
              <div class="dropdown-item loading">Searching...</div>
            </div>
            <div class="dropdown-results" *ngIf="showSpouseDropdown && !isLoadingRelatives && spouseSearchTerm.length >= 2 && spouseSearchResults.length === 0">
              <div class="dropdown-item no-results">No relatives found</div>
            </div>
          </div>
          <!-- Manual Referral Code Input (fallback) -->
          <div class="manual-code-input" *ngIf="selectedSpouse || spouseSearchTerm.length > 0 || (spouseReferralCode && signupForm.get('spouseReferralCode')?.value)">
            <div class="input-container">
              <div class="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                  <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
                </svg>
              </div>
            <input 
              type="text" 
              class="form-input"
              formControlName="spouseReferralCode"
                placeholder="Or enter referral code manually"
                [readonly]="selectedSpouse"
              (blur)="validateReferralCode()">
            <div class="input-focus-line"></div>
            </div>
            <small class="help-text" *ngIf="selectedSpouse">Referral code auto-filled from selection above</small>
            <small class="help-text" *ngIf="!selectedSpouse">You can also enter the referral code manually</small>
          </div>
          <small class="help-text" *ngIf="!selectedSpouse && !spouseSearchTerm">You can skip this and set spouse relationship later after login</small>
          </div>
        </div>

        <!-- Account Credentials Section -->
      <div class="form-section">
        <h3 class="section-title">Account Credentials</h3>
        <div class="section-description">We've generated secure credentials for you. You can edit them if needed.</div>

          <div class="form-row">
            <div class="form-group">
              <div class="input-container">
                <div class="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <input 
                  type="text" 
                  class="form-input"
                  formControlName="username"
                  [class.error]="signupForm.get('username')?.invalid && signupForm.get('username')?.touched"
                  placeholder="Username"
                  autocomplete="username">
              <button 
                type="button" 
                class="regenerate-btn-inline"
                (click)="regenerateCredentials()"
                title="Regenerate credentials">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <polyline points="23,4 23,10 17,10" stroke="currentColor" stroke-width="2"/>
                  <polyline points="1,20 1,14 7,14" stroke="currentColor" stroke-width="2"/>
                  <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
                <div class="input-focus-line"></div>
              </div>
              <div class="error-message" *ngIf="signupForm.get('username')?.invalid && signupForm.get('username')?.touched">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                  <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span *ngIf="signupForm.get('username')?.errors?.['required']">Username is required</span>
                <span *ngIf="signupForm.get('username')?.errors?.['minlength']">Username must be at least 3 characters</span>
              </div>
            </div>

            <div class="form-group">
              <div class="input-container">
                <div class="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                    <circle cx="12" cy="16" r="1" fill="currentColor"/>
                    <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </div>
                <input 
                  [type]="showPassword ? 'text' : 'password'" 
                  class="form-input"
                  formControlName="password"
                  [class.error]="signupForm.get('password')?.invalid && signupForm.get('password')?.touched"
                  placeholder="Password"
                  autocomplete="new-password">
                <button 
                  type="button" 
                  class="password-toggle"
                  (click)="togglePassword()"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                  <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20C5 20 1 12 1 12A18.45 18.45 0 0 1 5.06 5.06L17.94 17.94Z" stroke="currentColor" stroke-width="2"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4C19 4 23 12 23 12A18.5 18.5 0 0 1 19.34 16.34L9.9 4.24Z" stroke="currentColor" stroke-width="2"/>
                    <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
                <div class="input-focus-line"></div>
              </div>
              <div class="error-message" *ngIf="signupForm.get('password')?.invalid && signupForm.get('password')?.touched">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
                  <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
                </svg>
                <span *ngIf="signupForm.get('password')?.errors?.['required']">Password is required</span>
                <span *ngIf="signupForm.get('password')?.errors?.['minlength']">Password must be at least 6 characters</span>
              </div>
            </div>
        </div>
      </div>

      <!-- Privacy Agreement Section -->
      <div class="privacy-agreement-section">
        <div class="privacy-agreement-container">
          <label class="privacy-checkbox-label">
            <input 
              type="checkbox" 
              formControlName="acceptPrivacyAgreement"
              class="privacy-checkbox-input">
            <span class="privacy-checkbox-custom"></span>
            <span class="privacy-checkbox-text">
              I have read and agree to the 
              <a [routerLink]="['/privacy-policy']" class="privacy-link">Privacy Policy</a> 
              and 
              <a [routerLink]="['/terms-of-service']" class="privacy-link">Terms of Service</a>
            </span>
          </label>
          <div class="error-message" *ngIf="signupForm.get('acceptPrivacyAgreement')?.invalid && signupForm.get('acceptPrivacyAgreement')?.touched">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
              <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
            </svg>
            You must accept the privacy agreement to continue
          </div>
        </div>
      </div>

      <!-- Submit Button -->
          <button 
            type="submit" 
          class="submit-button"
          [disabled]="signupForm.invalid || isLoading"
          [class.loading]="isLoading">
          <span class="button-content">
            <svg *ngIf="isLoading" class="loading-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
                <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
              </circle>
            </svg>
            <span class="button-text">{{ isLoading ? 'Creating Account...' : 'Create Account' }}</span>
          </span>
          </button>

      <!-- Error Message -->
      <div class="error-alert" *ngIf="errorMessage" [class.show]="errorMessage">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
          <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
        </svg>
        {{ errorMessage }}
      </div>

      <!-- Success Message -->
      <div class="success-alert" *ngIf="successMessage" [class.show]="successMessage">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 11.08V12A10 10 0 1 1 5.93 5.93" stroke="currentColor" stroke-width="2"/>
          <polyline points="22,4 12,14.01 9,11.01" stroke="currentColor" stroke-width="2"/>
        </svg>
        {{ successMessage }}
        <div *ngIf="credentials" class="credentials-info">
          <div class="credential-item">
            <strong>Username:</strong> {{ credentials.username }}
          </div>
          <div class="credential-item">
            <strong>Password:</strong> {{ credentials.password }}
          </div>
          <div class="credential-item">
            <strong>Referral Code:</strong> {{ credentials.referralCode }}
          </div>
        </div>
      </div>
    </form>

    <!-- Footer -->
    <div class="signup-footer">
      <p class="login-prompt">Already have an account?</p>
      <button 
        type="button"
        class="login-button"
        routerLink="/login">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15M10 17L15 12M15 12L10 7M15 12H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Sign In</span>
      </button>
    </div>
  </div>
</div>
